import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../Components/UI/Button/Button";
import ButtonWithBG from "../../Components/UI/ButtonMain";
import SearchField from "../../Components/UI/SearchField";
import DashBoardLayout from "../../Layouts/private/DashboardLayout";
// import { SEARCH_PLACEHOLDER } from "../../Utils/Constants";
import CommissionEntryTable from "../../Components/DataTables/CommissionEntryTable";
import { setting_svg } from "../../Utils/SVGListing";

const CommissionEntry = () => {
  const [searchValue, setSearchValue] = useState("");
  const history = useHistory();

  // To redirect to add page
  const redirectToAddCommission = () => {
    history.push({
      pathname: "/commission-entry/add-edit-commission",
      state: { label: "Add" },
    });
  };

  return (
    <DashBoardLayout pageTitle="Commission Entry">
      <div className="min-w-full space-y-4">
        {/* <Divider subtitle="Commission Entry"/> */}
        {/* Search and setting */}
        <div className="flex flex-row justify-between">
          <div>
            <SearchField
              placeholder="Enter Value to search"
              handleChange={setSearchValue}
              value={searchValue}
              setSearchValue={setSearchValue}
            />
          </div>
          <div className="flex flex-row space-x-2">
            <Button svg={setting_svg}></Button>
            <ButtonWithBG
              handleClick={redirectToAddCommission}
              theme="primary"
              label="Add Commission"
            />
          </div>
        </div>
      </div>
      <CommissionEntryTable searchValue={searchValue} />
    </DashBoardLayout>
  );
};

export default CommissionEntry;
